/* MADNAILZ – Fiche produit : lance automatiquement la 1re vidéo de la galerie (sans son, en boucle) */
(function () {
  function prep(v) {
    v.muted = true; v.setAttribute('muted', '');
    v.defaultMuted = true;
    v.playsInline = true; v.setAttribute('playsinline', '');
    v.loop = true; v.setAttribute('loop', '');
    v.removeAttribute('controls');
  }
  function start() {
    var dm = document.querySelector('.product-media deferred-media');
    if (!dm) return;
    // Prépare aussi la vidéo du modèle avant qu'elle soit clonée
    var tpl = dm.querySelector('template');
    if (tpl && tpl.content) {
      var tv = tpl.content.querySelector('video');
      if (tv) { prep(tv); tv.setAttribute('autoplay', ''); }
    }
    if (typeof dm.loadContent === 'function') {
      dm.loadContent(false);
      dm.isPlaying = true;
      if (typeof dm.updatePlayPauseHint === 'function') dm.updatePlayPauseHint(true);
    }
    var vids = dm.querySelectorAll('video');
    var v = vids[vids.length - 1];
    if (!v) return;
    prep(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function init() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('deferred-media').then(function () { setTimeout(start, 50); });
    } else {
      start();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
